/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { FaNotEqual, FaTag } from 'react-icons/fa';
import $ from 'jquery';
import './style.scoped.scss';
import Tag from '../../Tag';
import { connect } from 'react-redux';
import { AiOutlineFileText } from 'react-icons/ai';
import { addCustomTags, ClearTag, displayDocVersion, ROUTES } from '../../../assets/constants/strings';
import { Link } from 'react-router-dom';

const ComparisonDocument = ({
  hasLink,
  document: comparisonDoc,
  filteredPages,
  handleTagSelected,
}) => {
  // pagination number
  const [selectedPageIndex, setSelectedPageIndex] = useState(1);

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  });

  useEffect(() => {
    filteredPages.length < selectedPageIndex && setSelectedPageIndex(1);
  }, [filteredPages]);

  const handleSelected = (tag) => {
    handleTagSelected(tag);
  };

  const renderTags = () => {

    const div = document.createElement('div');
    div.innerHTML = selectedPage.HTMLContent;
    const textContent = div.textContent;

    return (
      selectedPage.tags &&
      addCustomTags(
        selectedPage.tags,
        textContent,
        comparisonDoc
      )
        .split(',')
        .map((tag, i) => {
          if (tag.match('CUSTOMTAG')) {
            // custom tag
            return (
              <div
                onClick={() => handleTagSelected(ClearTag(tag))}
                key={tag.trim()}
                className="tag badge px-2 py-1 m-1 custom-tag"
              >
                <span>{ClearTag(tag)}</span>
              </div>
            );
          } else if (
            !(
              tag.trim().length <= 2 || // has two characters
              tag.match(/[^0-9a-z!\s]/gi) || // has non alphanumeric chars
              (tag.match(/\d/g) && tag.match(/\d/g).length > 1)
            ) // has more than one number
          ) {
            return <Tag text={tag.trim()} handleSelected={handleSelected} key={i} />;
          } else return null;
        })
    );
  };

  const handlePaginationClick = (selectedItem) => {
    setSelectedPageIndex(selectedItem.selected + 1);
  };

  const selectedPage = filteredPages[selectedPageIndex - 1];

  return (
    <div>
      <div className="col comparison-doc-wrapper">
        {/* Document Title */}
        <h3 id="documentName" className="pb-3 heading-override wf-border-b text-center">
          <AiOutlineFileText className="mr-2" /> {displayDocVersion(comparisonDoc)}
        </h3>
        {selectedPage ? (
          <div>
            {/* Page Title */}
            {hasLink ? (
              <Link
                to={ROUTES.DOCUMENT(comparisonDoc.slug, selectedPage.slug)}
                target="_blank"
                rel="noreferrer"
                title="Go to document on new tab"
              >
                <h4 id="pageTitle" className="my-3 heading-override text-center">
                  {selectedPage.title}
                </h4>
              </Link>
            ) : (
              <h4 id="pageTitle" className="my-3 heading-override text-center">
                {selectedPage.title}
              </h4>
            )}

            {/* Page Content */}
            <div id="content" dangerouslySetInnerHTML={{ __html: selectedPage.HTMLContent }}></div>

            {/* Tags */}
            <div className="tags d-flex pt-2 wf-border-t">
              <FaTag className="mr-2" fontSize="1.45rem" />
              <div className="d-flex flex-wrap">{renderTags()}</div>
            </div>
            {filteredPages.length > 1 && (
              <div className="text-center mt-4 pagination-wrapper">
                <ReactPaginate
                  onPageChange={handlePaginationClick}
                  previousLabel={'previous'}
                  previousClassName={'paginate-previous'}
                  nextLabel={'next'}
                  nextClassName={'paginate-next'}
                  breakLabel={'...'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  pageCount={filteredPages.length}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={10}
                  containerClassName={'pagination pagination-sm'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  activeClassName={'page-item active'}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="no-match">
            <h3>No Matches Found</h3>
            <h3>
              <FaNotEqual />
            </h3>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  documents: state.client.documents,
});

const connector = connect(mapStateToProps, null);

export default connector(ComparisonDocument);
